import { ArrowDown } from "./ArrowDown";
import { ArrowUp } from "./ArrowUp";
import { ChevronRight } from "./ChevronRight";
import { CloseOutlined } from "./CloseOutlined";
import { Edit } from "./Edit";
import { Minus } from "./Minus";
import { Plus } from "./Plus";
import { SearchIcon } from "./SearchIcon";
import { Check } from "./Check";
import { Close } from "./Close";
import { File } from "./File";
import { Lock } from "./Lock";
import { UploadFileAlt } from "./UploadFileAlt";

export {
  ChevronRight,
  Minus,
  Plus,
  ArrowDown,
  ArrowUp,
  CloseOutlined,
  Edit,
  SearchIcon,
  Check,
  Close,
  File,
  Lock,
  UploadFileAlt,
};
